import { flow, get } from 'lodash/fp';

export const getClients = get('clients');
export const datasetsOptions = flow(getClients, get('datasetsOptions'));
